import { Injectable } from '@angular/core';

import { divisoesStorage } from "./data.service";
import {SetorNavigationService} from "../../setores/shared/setor-navigation.service";
import {SetorService} from "../../setores/shared/setor.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {setoresStorage} from "../../setores/shared/data.service";
import {FrotaNavigationService} from "../../../bens/frotas/shared/frota-navigation.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {frotasStorage} from "../../../bens/frotas/shared/data.service";

@Injectable()
export class DivisoesService {

  constructor(
    private _setorNavigationService: SetorNavigationService,
    private _setorService: SetorService,
    private _frotaNavigationService: FrotaNavigationService,
    private _frotaService: FrotasService,
    
    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(divisoesStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(divisoesStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(divisoesStorage + "-new");
  }

  returnToOtherForm(otherForm: string, Response: any) {
    if(Response) {
      var otherFormObject: any;

      if (otherForm === setoresStorage) {
        otherFormObject = this._setorService.getSessionStorage();
        otherFormObject.divisao = Response;
        this._setorService.setSessionStorage(otherFormObject);
      } else if (otherForm === frotasStorage) {
        otherFormObject = this._frotaService.getSessionStorage();
        otherFormObject.divisao = Response;
        this._frotaService.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(divisoesStorage);

    if (otherForm === setoresStorage) {
      otherFormObject = this._setorService.getSessionStorage();
      if (otherFormObject.id) {
        this._setorNavigationService.goToEdit(otherFormObject.id);
      } else {
        this._setorNavigationService.goToNew();
      }
    } else if (otherForm === frotasStorage) {
      otherFormObject = this._frotaService.getSessionStorage();
      var frotasRoute = otherFormObject.thisRoute;
      if (otherFormObject.id) {
        this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
      } else {
        this._frotaNavigationService.goToNew(frotasRoute);
      }
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/divisoes/shared/divisao.service.ts
 **/